<template>
  <div class="photo" :class="{ inApp: $root.$data.isApp || $root.miniprogram }">
    <common-title titleName="图片识别" :bcColor="'#F7F8FC'" :zIndex="1000"></common-title>
    <div v-if="!isSubmit">
      <div class="photo-content" v-show="isEmpty">
        <div class="photobg">
          <van-image
            width="100"
            height="100"
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/photobg.png"
          />
          <p>晒宇哥图书，获抽卡次数</p>
        </div>
      </div>
      <UploadImage @getListFile="getListFile" @cardSubmit="cardSubmit" />
    </div>
    <div v-if="isSubmit">
      <PhotoIdentifing :fileList="fileList" />
    </div>
  </div>
</template>

<script>
import UploadImage from './component/uploadImage';
import PhotoIdentifing from './component/photoIdentifing';

export default {
  components: {
    UploadImage,
    PhotoIdentifing,
  },
  data() {
    return {
      isEmpty: true,
      isSubmit: false,
      fileList: [],
    };
  },

  computed: {},
  created() {},

  mounted() {
    document.title = '图片识别';
  },

  methods: {
    getListFile(file) {
      // console.log(file, 111);
      if (file.length > 0) {
        this.isEmpty = false;
        this.fileList = [...file];
      }
    },

    cardSubmit() {
      this.isSubmit = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.photo {
  padding-top: 100px;
  background-color: #f7f8fc;
  &.inApp {
    padding-top: 0;
  }
  .photo-content {
    height: calc(100vh - 100px - 167px);
    display: flex;
    justify-content: center;
    align-items: center;
    .photobg {
      .van-image {
        display: block;
        width: 120px;
        height: 120px;
        margin: 0 auto;
      }
      p {
        font-weight: 400;
        font-size: 25px;
        color: #333333;
        text-align: center;
        margin-top: 30px;
      }
    }
  }
}
</style>
